<template>
  <b-card class="mb-1" no-body>
    <b-card-header class="p-0" header-tag="header" role="tab">
      <b-button
          v-b-toggle:[toggle]
          block
          class="text-left d-flex"
          squared
      >
        <span class="w-100">{{ cardTitle }}</span><span class="when-open"><b-icon-arrow-down-short></b-icon-arrow-down-short></span><span class="when-closed"><b-icon-arrow-right-short></b-icon-arrow-right-short></span></b-button>
    </b-card-header>
    <b-collapse :id="toggle" :visible="visible" accordion="accordion" role="tabpanel">
      <b-card-body>
        <slot></slot>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  name: "cm-card",
  props: {
    toggle: {
      type: String,
      required: true,
    },
    cardTitle: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: false,
    },
  },
}
</script>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>